import React, { useEffect, useState } from "react";
import { TableContainer, Paper, Button } from "@mui/material";
import { Link } from "react-router-dom";

// material-ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import DisplayExport from "../../../components/Exports/DisplayExport";
import getNameByID from "../../../../functions/getNameByID";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_One_From_MongoDB_No_State_Just_Return } from "../../../api/Get_One_From_MongoDB_No_State_Just_Return";
import getTextBeforeAtSymbol from "../../../../functions/getTextBeforeAtSymbol";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
// material-ui

function ViewTransactions() {
  const { logout } = StaffuseAuth();

  const [Arr_Transactions, setArr_Transactions] = useState([]);
  const [Arr_Invoices, setArr_Invoices] = useState([]);
  const [Arr_Attendees, setArr_Attendees] = useState([]);

  useEffect(() => {
    Get_All_From_MongoDB("Invoices", "Xero_2025", setArr_Invoices);
    Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
      "Invoices",
      "Transactions_2025",
      { Handled: { $nin: ["Handled"] } },
      10000,
      setArr_Transactions,
      { Import_Date: 1 },
      {},
      logout
    );
    Get_limited_Choose_Fields_From_MongoDB_With_Search(
      "Registers_2025",
      "All",
      {},
      10000,
      setArr_Attendees,
      { _id: 1, "MetaData.PrimaryStaff": 1, "IPInfo.EC_ID": 1 },
      logout
    );
  }, []);

  let Arr_PropsToSee = [
    "Import_Date",
    "Invoice_Number",
    "Contact",
    "Gross_GBP",
    "Status",
  ];

  function FindInvoiceByInvoiceNumberAndReturn(Invoice_Number) {
    //Find the invoice in Arr_Invoices with the value of Invoice_Number in the prop Invoice_Number. If non can be found, return "No"
    let Local_Obj_Invoice = Arr_Invoices.find(
      (Local_Obj_Invoice) => Local_Obj_Invoice.Invoice_Number === Invoice_Number
    );
    return Local_Obj_Invoice ? Local_Obj_Invoice : "No";
  }

  function ReturnButtonToGoToInvoice(Obj_Invoice, Invoice_Number) {
    return Obj_Invoice === "No" ? (
      <Button variant="contained" color="primary" disabled={true}>
        No Invoice Found Matching {Invoice_Number}
      </Button>
    ) : (
      <Link
        to={`/Staff/ViewInvoice/${Obj_Invoice._id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <button>View Invoice</button>
      </Link>
    );
  }

  function ReturnRowsForEachAttendeeInTheAttendeeArray(Obj_Invoice) {
    if (Obj_Invoice) {
      if (
        Array.isArray(Obj_Invoice.Attendees) &&
        Obj_Invoice.Attendees.length > 0
      ) {
        return Obj_Invoice.Attendees.map((Obj_Attendee, index) => {
          let Found_Obj_Attendee = Arr_Attendees.find(
            (Obj_Find_Attendee) =>
              Obj_Find_Attendee._id === Obj_Attendee.Attendee_id
          );

          return (
            <TableRow key={index} sx={{ fontStyle: "italic" }}>
              <TableCell sx={{ backgroundColor: "#e0e0e0" }}></TableCell>
              <TableCell sx={{ backgroundColor: "#e0e0e0" }}></TableCell>
              <TableCell sx={{ backgroundColor: "#e0e0e0" }}></TableCell>
              <TableCell sx={{ backgroundColor: "#e0e0e0" }}></TableCell>
              <TableCell
                sx={{
                  wordBreak: "break-all",
                  whiteSpace: "normal",
                }}
              >
                Sub Amount: £{Obj_Attendee.SubAmount}
              </TableCell>
              <TableCell sx={{ backgroundColor: "#e0e0e0" }}></TableCell>
              <TableCell
                sx={{
                  wordBreak: "break-all",
                  whiteSpace: "normal",
                }}
              >
                {Found_Obj_Attendee?.MetaData?.PrimaryStaff
                  ? getTextBeforeAtSymbol(
                      getNameByID(
                        Arr_Staff,
                        Found_Obj_Attendee?.MetaData?.PrimaryStaff,
                        "Username"
                      )
                    )
                  : "No Staff Assigned To Attendee"}
              </TableCell>
              <TableCell>
                {Obj_Attendee.Attendee_id &&
                Obj_Attendee.Attendee_id.length === 24 ? (
                  <Link
                    to={`/Staff/ViewAttendee/${Obj_Attendee.Attendee_id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button
                      style={{
                        padding: "6px 8px",
                        fontSize: "0.8em",
                      }}
                    >
                      View Attendee
                    </button>
                  </Link>
                ) : (
                  <button
                    style={{
                      padding: "6px 8px",
                      fontSize: "0.8em",
                      backgroundColor: "grey",
                      cursor: "not-allowed",
                      border: "none",
                      opacity: 0.5,
                    }}
                    disabled
                  >
                    Not an Attendee
                  </button>
                )}
              </TableCell>
              <TableCell
                sx={{
                  wordBreak: "break-all",
                  whiteSpace: "normal",
                }}
              >
                {Found_Obj_Attendee?.IPInfo?.EC_ID &&
                Found_Obj_Attendee.IPInfo.EC_ID.length > 0 ? (
                  <Link
                    to={`/Staff/ViewEC/${Found_Obj_Attendee.IPInfo.EC_ID}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button
                      style={{
                        padding: "6px 8px",
                        fontSize: "0.8em",
                      }}
                    >
                      View EC
                    </button>
                  </Link>
                ) : (
                  "Non EC Booking"
                )}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                sx={{
                  padding: "8px",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
              ></TableCell>
            </TableRow>
          );
        });
      }
    }
    return;
  }

  //The below gets the staff
  const [Arr_Staff, setArr_Staff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "Staff",
      "Users",
      100,
      { Username: 1 },
      setArr_Staff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      }
    );
  }, []);

  function handleGetAllData(e) {
    Get_All_From_MongoDB("Invoices", "Transactions_2025", setArr_Transactions);
  }

  const [UpdateStatus, setUpdateStatus] = useState(false);

  function handleMarkAsHandled(e, Obj_Transaction, index) {
    Update_To_MongoDB_By_ID(
      { Staff_id: localStorage.getItem("_id"), Handled: "Handled" },
      "Invoices",
      "Transactions_2025",
      setUpdateStatus,
      Obj_Transaction._id
    );
    //Update the array Arr_Transactions , such that the object at index, is given the proprty Handled: "Handled"
    let updatedArr_Transactions = [...Arr_Transactions];
    updatedArr_Transactions[index] = {
      ...updatedArr_Transactions[index],
      Handled: "Handled",
      Staff_id: localStorage.getItem("_id"),
    };
    setArr_Transactions(updatedArr_Transactions);
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Transactions</h1>

        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <h2>View All Transactions</h2>
          <DisplayExport excelData={Arr_Transactions} fileName="Invoices" />
          <button
            style={{ maxWidth: "5%", maxHeight: "100px" }}
            onClick={(e) => handleGetAllData(e)}
          >
            Get All
          </button>
        </div>

        <section>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {SimpleTableHeader("Handled")}
                  {Arr_PropsToSee && Array.isArray(Arr_PropsToSee) ? (
                    Arr_PropsToSee.map((Obj_PropToSee, index) =>
                      SimpleTableHeader(Obj_PropToSee)
                    )
                  ) : (
                    <></>
                  )}
                  {SimpleTableHeader("Staff Assigned To Invoice/Attendee")}
                  {SimpleTableHeader("View Attendees / Invoice")}
                  {SimpleTableHeader("View EC")}
                  {SimpleTableHeader("View Transaction")}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow style={{ border: "1px solid black" }}></TableRow>
                {Arr_Transactions && Array.isArray(Arr_Transactions) ? (
                  Arr_Transactions.map(
                    (Obj_Transaction, Obj_Transaction_index) => {
                      let Obj_Invoice = FindInvoiceByInvoiceNumberAndReturn(
                        Obj_Transaction.Invoice_Number
                      );

                      return (
                        <>
                          <TableRow
                            key={Obj_Transaction_index}
                            sx={{
                              "&:hover": {
                                backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                                "& .MuiTableCell-root": {
                                  padding: "8px",
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word", // Adjust padding here to make cells smaller
                                },
                              },
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                backgroundColor:
                                  Obj_Transaction.Handled === "Handled"
                                    ? "rgba(0, 128, 0, 0.3)" // Soft green with 30% opacity
                                    : "rgba(255, 0, 0, 0.3)", // Soft red with 30% opacity
                              }}
                            >
                              {Obj_Transaction.Handled === "Handled" ? (
                                "Handled by " +
                                getTextBeforeAtSymbol(
                                  getNameByID(
                                    Arr_Staff,
                                    Obj_Transaction.Staff_id,
                                    "Username"
                                  )
                                )
                              ) : (
                                <>
                                  UnHandled
                                  <Button
                                    variant="contained"
                                    onClick={(e) =>
                                      handleMarkAsHandled(
                                        e,
                                        Obj_Transaction,
                                        Obj_Transaction_index
                                      )
                                    }
                                  >
                                    Mark As Handled
                                  </Button>
                                </>
                              )}
                            </TableCell>
                            {Arr_PropsToSee && Array.isArray(Arr_PropsToSee) ? (
                              Arr_PropsToSee.map((Obj_PropToSee, index) => (
                                <TableCell
                                  component="th"
                                  scope="row"
                                  sx={{
                                    padding: "8px",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {Obj_Transaction[Obj_PropToSee]}
                                </TableCell>
                              ))
                            ) : (
                              <></>
                            )}
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                              }}
                            >
                              {getTextBeforeAtSymbol(
                                getNameByID(
                                  Arr_Staff,
                                  Obj_Invoice.Staff_id,
                                  "Username"
                                )
                              )}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                              }}
                            >
                              {ReturnButtonToGoToInvoice(
                                Obj_Invoice,
                                Obj_Transaction.Invoice_Number
                              )}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                              }}
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                              }}
                            >
                              <Link
                                to={`/Staff/ViewTransaction/${Obj_Transaction._id}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                <button>View Transaction </button>
                              </Link>
                            </TableCell>
                          </TableRow>
                          {ReturnRowsForEachAttendeeInTheAttendeeArray(
                            Obj_Invoice
                          )}
                          <TableRow
                            key={"Obj_Transaction_index"}
                            style={{ border: "1px solid black" }}
                          ></TableRow>
                        </>
                      );
                    }
                  )
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </section>
        <div style={{ marginTop: "20px" }}></div>
      </section>
    </div>
  );
}

export default ViewTransactions;
